import { memo } from 'react';
import { Spinner } from 'react-bootstrap';

interface LoadingSpinnerProps {
  readonly message?: string;
}

export const LoadingSpinner = memo<LoadingSpinnerProps>(function LoadingSpinner({
  message = 'Loading...',
}) {
  return (
    <div className="d-flex flex-column align-items-center justify-content-center py-5">
      <Spinner animation="border" role="status" variant="primary">
        <span className="visually-hidden">{message}</span>
      </Spinner>
      <p className="mt-3 text-muted">{message}</p>
    </div>
  );
});
